export const typeOfDisputeOptions = [
  { label: "Fraud (Unauthorised transactions)", value: "dispute_type_fraud" },
  {
    label: "ATM Dispute (cash not dispensed from ATM)",
    value: "dispute_type_atm_dispute",
  },
  {
    label: "Duplicate Transaction",
    value: "dispute_type_duplicate_transaction",
  },
  {
    label:
      "Purchase Details (charged incorrect amount, goods/service not received, posted incorrect date)",
    value: "dispute_type_purchase_details",
  },
  {
    label: "Retail Finance (Interest Free Promotion)",
    value: "dispute_type_retail_finance",
  },
] as const;
